import MomentUtils from '@date-io/moment';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import RefreshIcon from '@material-ui/icons/Refresh';
import { KeyboardDateTimePicker, DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DefaultSettings from '../settings';
import { Clear } from '@material-ui/icons';


const useStyles = makeStyles((theme) => ({
    root: {
        "& label": {
            // color: "white"
        },
        // "& .MuiInput-underline:before": {
        //     borderBottomColor: "white"
        // },
        // "& .MuiInput-underline:after": {
        //     borderBottomColor: "white"
        // },
        "& .MuiInputBase-input": {
            // color: "white",
            fontSize: 11
        },
        "& .MuiInputBase-root": {
            // color: "white",
            fontSize: 11
        },
        "& .MuiIconButton-root": {
            // color: "white",
        },
        "& .MuiFormLabel-root": {
            //  color: "white",
            fontSize: 11
        },
        "& .MuiSvgIcon-root": {
            // color: "white",
            fontSize: 16
        },
        "& .MuiInput-formControl": {
            marginTop: 4
        }

    }
}));
function DatePopover({ anchorEl, setAnchorEl, ...props }) {
    //const [anchorEl, setAnchorEl] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [tempDate, setTempDate] = useState(new Date());
    const classes = useStyles();
    const { value, handleFieldValue, name, extraProps, shareProps, ...otherProps } = props
    const { label, xtype, fullWidth, tooltip, FieldProps, onAsOfDateChanged, clearAsOfDateChanged, HeaderFieldProps, error, required, contexthelp, ...otherConfigs } = otherProps;
    const [range, setRange] = useState({})
    const [reload, setReload] = useState(false)

    let val = ((value === null) || (value === undefined) || (value === '')) ? '' : value;
    val = val ? moment(val).format('MM/DD/YYYY hh:mm:ss') : '';
    useEffect(() => {
    setTempDate(val);}, [val])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDateChange = (date) => {
        setTempDate(date);
    };

    const handleOk = () => {
        setSelectedDate(tempDate);
        handleClose();
        onAsOfDateChanged(tempDate);
    };
    const handleRefresh = () => {
        const currentDate = new Date();
        setSelectedDate(currentDate);
        setTempDate(currentDate);
        handleClose();
        clearAsOfDateChanged(currentDate);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    /*<IconButton onClick={handleClick}>
        <DateRangeIcon />
    </IconButton>
    */let currentDate = 'N';
    let passDate = false;
    let pastDate = false;
    let futureDate = false;
    let fieldprops = null;
    let fieldAllowedProps = null;
    let currdate = false;
    let headerfieldprops = HeaderFieldProps || null;

    if (FieldProps) {
        fieldprops = JSON.parse(FieldProps)
        currentDate = ((fieldprops && (fieldprops['CurrentDefaultDate'] === true || fieldprops['CurrentDefaultDate'] === 'Y')) ||
            (fieldAllowedProps && fieldAllowedProps['CurrentDefaultDate'] === 'Y')) ? 'Y' : 'N';
        // currentDate = fieldprops['CurrentDefaultDate'];
        if (currentDate && value === '') {
            val = new Date()
        }
        if (fieldprops['AllowDate'] === 'CD') {
            passDate = true;
            futureDate = true;
        }
        else if ((fieldprops && fieldprops['AllowDate'] === 'PD') && currentDate == 'Y') {
            pastDate = true;
            futureDate = false;
            currdate = true;
        }
        else if (fieldprops['AllowDate'] === 'PD') {
            passDate = false;
            futureDate = true;
        }

        else if (fieldprops['AllowDate'] === 'FD') {
            passDate = true;
            futureDate = false;
        }
    }
    else if (headerfieldprops) {
        if (headerfieldprops['AllowDate'] === 'PD') {
            passDate = false;
            futureDate = true;
        }
    }

    useEffect(() => {
        if (passDate) {
            range['maxDate'] = (val === '' ? new Date() : new Date(val))
            setRange(range)
            setReload(!reload)
        }
        else if (futureDate) {
            range['minDate'] = (val === '' ? new Date() : new Date(val));
            setRange(range)
            setReload(!reload)
        }
    }, [])

    let tlabel = <Typography variant='caption' color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
        {tooltip && <Tooltip title={tooltip ? tooltip : null}
            placement="bottom-start" >
            <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                onClick={(evt) => contexthelp ?
                    DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
        </Tooltip>}
    </Typography>
    if (handleFieldValue === "hidedisplay") {
        return null
    }
    else return (

        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        > <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                    cancelLabel="Cancel"
                    okLabel="OK"
                    //disableToolbar
                    variant="static"
                    color='primary'
                    ampm={false}value={tempDate}
                    //value={((val === '') ? new Date() : val) || null} //currentDate
                    disablePast={passDate}
                    disableFuture={futureDate}
                    onChange={(e) => handleDateChange(e)}
                    label={tlabel}
                    TextFieldComponent={() => null}
                    name={name}
                    {...range}
                    {...otherConfigs}
                    {...extraProps}
                    format="MM/DD/YYYY hh:mm:ss"
                    className={classes.root}
                /></MuiPickersUtilsProvider>
            <DialogActions>
                <Button color="primary"  onClick={handleClose}>Cancel</Button>
                <Button color="primary"  onClick={handleOk}>OK</Button>
                <IconButton color="primary" size='small' component="clear"  onClick={(e) => handleRefresh(e)}>
                    <Clear />Clear
                </IconButton>
            </DialogActions>
        </Popover>


    );
}

export default DatePopover;